import { MatchedProductCount } from "./groupMatchedProductsByBrand";

// The matched_item facet returns matched products of every type in one list.
// A tab keeps only its own product class, read from the id: item/<class>/<number>.
export const countsForProductClass = (counts: MatchedProductCount[], productClass: string) => {
  const productIdPrefix = `item/${productClass.toLowerCase()}/`;
  return counts.filter(({ id }) => id?.startsWith(productIdPrefix));
};
